<template>
    <div :class="isMobile?'calculated-rappel-mobile':''">
        <div class="mx-4 elevation-1">
            <div class="d-flex py-2 px-4 btn-bg-color-dark-blue white--text" style="border-radius: 8px 8px 0px 0px">
                <span class="mr-auto font-size-md"> {{ tb('DESCONTOS EXCLUSIVOS QUANTIDADE') }} {{ getTitle }} </span>

                <span class="font-weight-bold">{{ formatPrice(rappelTotals.total_sales) }}</span>
            </div>

            <v-row class="discounts">
                <v-col cols="8" >
                    <div class="pl-16 d-flex align-center fill-height">
                        <div>
                            <p class="dark-blue-color font-weight-bold font-size-sm my-0">{{ tb('VALOR EXCLUÍDO DO CÁLCULO DE RAPPEL') }}</p>
                            <p class="text-caption font-size-xs my-0">{{ tb('(As famílias excluídas do cálculo de rappel têm uma política comercial própria)') }}</p>
                        </div>
                    </div>
                </v-col>

                <v-col cols="4">
                    <div class="mt-6 d-flex justify-space-between pr-4">
                        <span class="text-caption mr-auto">{{ tb('Compras Affinity') }}</span>
                        <span class="secondary-blue-color">{{ formatPrice(rappelTotals.value_affinity) }}</span>
                    </div>

                    <div class="my-4 datatable-footer-border"></div>

                    <div class="d-flex justify-space-between pr-4">
                        <span class="text-caption mr-auto">{{ tb('Compras Humana') }}</span>
                        <span class="secondary-blue-color">{{ formatPrice(rappelTotals.value_humana) }}</span>
                    </div>

                    <div class="my-4 datatable-footer-border"></div>

                    <div class="d-flex justify-space-between pr-4">
                        <span class="text-caption mr-auto">{{ tb('Compras KONG') }}</span>
                        <span class="secondary-blue-color">{{ formatPrice(rappelTotals.value_kong) }}</span>
                    </div>

                    <div class="my-4 datatable-footer-border"></div>

                    <div class="d-flex justify-space-between pr-4">
                        <span class="text-caption mr-auto">{{ tb('Compras Tolsa') }}</span>
                        <span class="secondary-blue-color">{{ formatPrice(rappelTotals.value_tolsa) }}</span>
                    </div>

                    <div class="my-4 datatable-footer-border"></div>
                </v-col>
            </v-row>

            <div class="pl-16 d-flex justify-space-between pr-4">
                <span class="text-caption font-weight-bold mr-auto">{{ tb('Valor para cálculo do Rappel') }}</span>
                <span>{{ formatPrice(getRappelValue) }}</span>
            </div>

            <div v-if="rappelNormalTotals" class="my-4 datatable-footer-border"></div>

            <div v-if="rappelNormalTotals" class="pl-16 d-flex justify-space-between pr-4">
                <span class="text-caption font-weight-bold mr-auto">{{ $t('rappel.normalToPay', { pct: rappelNormalTotals.rappel_percentage_to_pay }) }}</span>
                <span>{{ formatPrice(getRappelValue * (rappelNormalTotals.rappel_percentage_to_pay / 100)) }}</span>
            </div>

            <div v-if="rappelExclusiveTotals" class="my-4 datatable-footer-border"></div>

            <div v-if="rappelExclusiveTotals" class="pl-16 d-flex justify-space-between pr-4">
                <span class="text-caption font-weight-bold mr-auto">{{ $t('rappel.exclusiveToPay', { pct: rappelExclusiveTotals.rappel_percentage_to_pay }) }}</span>
                <span>{{ formatPrice(getRappelValue * (rappelExclusiveTotals.rappel_percentage_to_pay / 100)) }}</span>
            </div>

            <div class="pt-4"></div>
        </div>

        <v-row v-if="selectedPartition.at(partitions) && currentLevel && contract && contract.use_steps && rappelLevels.length > 1" class="mt-4 mx-1">
            <v-col cols="7" class="bar-chart-rappel-content">
                <div class="elevation-2 pt-6 px-8" style="border-radius: 8px">
                    <bar-chart alignTitleLeft horizontal height="385px" :title="'Rappel ' + getCurrentRappelTitle" :subtitle="tb('Ponto de situação dos escalões')" :annotations="rappelAnnotations" :series="[{ data: rappelLevels }]"></bar-chart>
                </div>
            </v-col>

            <v-col cols="5" class="level-content">
                <div class="elevation-1">
                    <div class="d-flex py-2 px-4 btn-bg-color-dark-blue white--text" style="border-radius: 8px 8px 0px 0px">
                        <span class="mr-auto font-size-md">PATAMAR ATUAL - {{ currentLevel.id }}º ESCALÃO</span>

                        <span class="font-weight-bold" v-if="checkIfToHiddenLevel(currentLevel)">{{ $t('rappel.range', { from: formatPrice(currentLevel.bottom_level), to: formatPrice(currentLevel.top_level) }) }}</span>
                        <span class="font-weight-bold" v-else > a partir de {{ formatPrice(currentLevel.bottom_level) }} </span>
                    </div>

                    <template v-for="(level, i) in getUpperLevels">
                        <div :key="i" class="d-flex pt-4 pb-2 px-4">
                            <span class="text-caption">{{ $t('rappel.tier', { n: level.id }) }}</span>
                            <span class="ml-auto text-caption">{{ tb('FALTA') }}</span>
                            <span class="ml-12 text-caption text-right" style="width: 135px">{{ formatPrice(level.amount_needed) }}</span>
                        </div>

                        <div v-if="i === getUpperLevels.length - 1" class="pb-2" :key="i + 'border'"></div>

                        <div v-else class="mt-2 datatable-footer-border" :key="i + 'border'"></div>
                    </template>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import moment from 'moment';

const DARK_BLUE_COLOR = '#154579';
const LIGHT_BLUE_COLOR = '#59ADDC';

export default {
    props: {
        filters: {
            type: Object,
            required: true,
        },

        selectedRappel: {
            type: Array,
            required: true,
        },

        contract: {
            type: Object,
        },

        levels: {
            type: Array,
            required: true,
        },

        selectedYear: {
            type: Number,
            required: true,
        },

        partitions: {
            type: Number,
            required: true,
        },

        selectedPartition: {
            type: Array,
            required: true,
        },

        contractCondition200NCC: {
            type: [String, null],
            required: false,
            default: null,
        },

        contractCondition250NCC: {
            type: [String, null],
            required: false,
            default: null,
        },
        contractCondition202CCE: {
            type: [String, null],
            required: false,
            default: null,
        },
        contractCondition203CCP: {
            type: [String, null],
            required: false,
            default: null,
        },
        contractCondition204CCNCE:{
            type: [String, null],
            required: false,
            default: null,
        },
        isMobile:{
            type: Boolean,
            default:false
        }
    },

    computed: {
        rappelTotals() {
            const initialState = { rappel_total: 0, total_sales: 0, rappel_total_sales: 0, value_affinity: 0, value_humana: 0, value_kong: 0, value_tolsa: 0 };
            return this.getRappelTotals('EXCLUSIVOS') || this.getRappelTotals('NORMAL') || initialState;
        },
        rappelNormalTotals() {
            return this.getRappelTotals('NORMAL');
        },
        rappelExclusiveTotals() {
            return this.getRappelTotals('EXCLUSIVOS');
        },

        /// This draws the vertical line that shows the client's rappel status.
        rappelAnnotations() {
            return [
                {
                    x: this.rappelTotals.rappel_total_sales,

                    borderColor: DARK_BLUE_COLOR,
                    label: {
                        style: {
                            color: '#fff',
                            background: DARK_BLUE_COLOR,
                        },
                        text: this.$t('rappel.currentValue'),
                    },
                },
            ];
        },

        rappelLevels() {
            // @Note: For the last level, the top value should be the bottom_level + 4000
            // This condition was requested by Propec
            const maxLevelId = Math.max(...this.levels.map((level) => level.id));
            const defaultValue = 4000;

            return this.calculateLevels(this.levels)
                .sort((a, b) => b.bottom_level - a.bottom_level) // descending
                .map((it) => {
                    const yValue = it.id === maxLevelId ? (this.rappelTotals.rappel_total_sales >= it.bottom_level + defaultValue ? this.rappelTotals.rappel_total_sales + defaultValue : it.bottom_level + defaultValue) : it.top_level;

                    const point = {
                        x: this.$t('rappel.tierLabel', { n: it.id }),
                        y: yValue,
                        real_y: it.top_level,
                    };

                    return it.id === this.currentLevel.id ? { ...point, fillColor: DARK_BLUE_COLOR } : { ...point, fillColor: LIGHT_BLUE_COLOR };
                });
        },

        getRappelValue() {
            return this.rappelTotals.rappel_total_sales;
        },

        getCurrentRappelTitle() {
            if (this.getRealSelectedMonth === 0) return ''; // If a month hasn't yet been selected.

            const currentYear = ` (${this.selectedYear})`;

            if (this.partitions === 1) {
                return this.capitalize(moment(this.getRealSelectedMonth, 'MM').locale(this.$i18n.locale).format('MMMM')) + currentYear;
            }

            if (this.partitions === 3) {
                switch (this.getRealSelectedMonth) {
                case 1:
                case 2:
                case 3:
                    return this.$t('rappel.quarter', { n: 1 }) + currentYear;
                case 4:
                case 5:
                case 6:
                    return this.$t('rappel.quarter', { n: 2 }) + currentYear;
                case 7:
                case 8:
                case 9:
                    return this.$t('rappel.quarter', { n: 3 }) + currentYear;
                case 10:
                case 11:
                case 12:
                    return this.$t('rappel.quarter', { n: 4 }) + currentYear;
                }
            }

            if (this.partitions === 6) {
                switch (this.getRealSelectedMonth) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    return this.$t('rappel.semester', { n: 1 }) + currentYear;
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                    return this.$t('rappel.semester', { n: 2 }) + currentYear;
                }
            }

            if (this.partitions === 12) {
                return this.$t('rappel.year') + currentYear;
            }

            return '';
        },

        currentLevel() {
            return this.calculateLevels(this.levels)
                .filter((level) => level.amount_needed < 0)
                .at(-1);
        },

        getUpperLevels() {
            return this.calculateLevels(this.levels).filter((level) => level.amount_needed > 0);
        },

        getTitle() {
            if (this.getCurrentRappelTitle === '') {
                const startDate = moment(this.filters.start_date).locale(this.$i18n.locale).format('MMMM YYYY');
                const endDate = moment(this.filters.end_date).locale(this.$i18n.locale).format('MMMM YYYY');

                return ' - ' + this.capitalize(startDate) + ' ' + this.$t('rappel.to') + ' ' + this.capitalize(endDate);
            }

            return '- ' + this.getCurrentRappelTitle;
        },

        getRealSelectedMonth() {
            return this.selectedPartition.at(this.partitions) ? moment(this.selectedPartition.at(this.partitions)).month() + 1 : 0;
        },
    },

    methods: {
        checkIfToHiddenLevel(row){
            if(row.top_level>=999999){
                return false
            }
            return true
        },
        getRappelTotals(type) {
            const initialSum = { rappel_total: 0, total_sales: 0, rappel_total_sales: 0, value_affinity: 0, value_humana: 0, value_kong: 0, value_tolsa: 0 };

            if (this.selectedPartition[this.partitions]) {
                // @Note: Get the totals for the selected radiobutton
                const rappelType = this.selectedRappel.filter((it) => it.document_type === type);
                if (rappelType.length === 0) {
                    return null;
                }

                return rappelType.reduce((acc, rappel) => {
                    acc.rappel_percentage_to_pay = rappel.rappel_percentage_to_pay;

                    for (const key of Object.keys(initialSum)) {
                        acc[key] += rappel[key];
                    }

                    return acc;
                }, Object.assign({}, initialSum));
            } else {
                // @Note: When no radiobutton is selected, it should sum all values ​​within the date range
                if (this.selectedRappel.length === 0) {
                    return null;
                }

                return this.selectedRappel.reduce((acc, rappel) => {
                    acc.rappel_percentage_to_pay = rappel.rappel_percentage_to_pay;

                    for (const key of Object.keys(initialSum)) {
                        acc[key] += rappel[key];
                    }

                    return acc;
                }, Object.assign({}, initialSum));
            }
        },

        calculateLevels(levels) {
            let counter = this.contract.condition === this.contractCondition200NCC || this.contract.condition === this.contractCondition202CCE || this.contract.condition === this.contractCondition203CCP  || this.contract.condition === contractCondition204CCNCE? 1 : 0;

            return levels.map((level) => {
                level.id = counter;
                level.amount_needed = level.bottom_level - this.rappelTotals.rappel_total_sales;

                counter += 1;

                return level;
            });
        },

        capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
    },
};
</script>
